module.exports = __webpack_public_path__ + "static/media/speaker_julian2.68296329.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/speaker_julian2.png
// module id = 218
// module chunks = 0